<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <base-material-card
          icon="mdi-timeline-clock-outline"
          title="Listado de usuarios"
          class="px-5 py-3"
        >
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          />
          <v-data-table
            :headers="headersTable1"
            :items="dataTable1"
            :search="search"
          >
            <!-- <template v-slot:item.key="{ item }"> -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                small
                color="primary"
                outlined
                @click="dialogUser(item)"
              >
                Investigar
              </v-btn>
              
              <details-students 
              :id="item.uid" 
              type-student="parent"
              />
            </template>
            
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      width="400"
    >
      <v-card>
        <v-card-title class="headline">
          {{ nameDialog }}
        </v-card-title>
        <v-subheader>Tipo de usuario: {{ typeDialog }}</v-subheader>
        <v-subheader>Id del usuario: {{ idDialog }}</v-subheader>
        <v-list-item
          v-if="productsDialog.length > 0"
          three-line
        >
          <v-list-item-content>
            <v-list-item-title>Productos</v-list-item-title>
            <v-list-item-subtitle
              v-for="(license, l) in productsDialog"
              :key="l"
            >
              <strong>{{ license.product_name }}</strong> {{ license.player_name === '' ? 'Disponible' : 'Activa' }} {{ license.player_name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-container
          v-if="typeDialog != 'Estudiante'"
        >
          <v-row>
            <v-col
              cols="12"
              class="text-center"
            >
              <v-select
                v-model="licenseSelected"
                :items="products"
                item-text="name"
                return-object
                filled
                label="Licencia"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="
          green
          darken-1"
            text
            dark
            :disabled="agregateLicense"
            @click="agregateLicenseUser()"
          >
            Agregar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import DetailsStudents from '@/views/dashboard/pages/panel/DetailsStudents'
  export default {
    components: {
      DetailsStudents
    },
    data () {
      return {
        agregateLicense: true,
        nameDialog: '',
        idDialog: '',
        typeDialog: '',
        productsDialog: [],
        dialog: false,
        search: '',
        levelSelected: 'Nivel 1',
        headersTable1: [
          {
            text: 'Nombre',
            align: 'start',
            value: 'name',
            sortable: false,
          },
          { text: 'Tipo de usuario', value: 'type', align: 'center', sortable: false },
          { text: 'Id', value: 'uid', align: 'center', sortable: false },
          { text: 'Acciones', value: 'actions', align: 'center', sortable: false },
        ],
        dataTable1: [],
        licenseSelected: '',
        addLicensesUrl: 'https://us-central1-videojuego-sh.cloudfunctions.net/addLicenses',
      }
    },
    computed: {
      ...mapState(['adminUsers', 'products', 'user']),
    },
    watch: {
      dialog (val) {
        if (!val) {
          this.licenseSelected = ''
          this.agregateLicense = true
        }
      },
      licenseSelected (val) {
        (val !== '') && (this.agregateLicense = false)
      },

    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.dataTable1 = this.adminUsers
      },
      dialogUser (user) {
        this.nameDialog = ''
        this.typeDialog = ''
        this.idDialog = ''
        this.productsDialog = []
        this.dialog = true
        this.nameDialog = user.name
        this.typeDialog = user.type
        this.idDialog = user.uid
        this.productsDialog = user.licensesUser
      },
      agregateLicenseUser () {
        this.$store.commit('SET_LOADING', true)
        const data = {}

        data.uid = this.idDialog
        data.quantity = this.licenseSelected.quantity
        data.productId = this.licenseSelected.id
        data.productName = this.licenseSelected.name

        this.$store.dispatch('ASSIGN_LICENSE', data)
        this.dialog = false
      },
    },
  }
</script>
